import "core-js/modules/es.array.push.js";
import navUser from './navUser';
import screenfull from 'screenfull';
import breadCrumb from './breadCrumb';
export default {
  name: 'navBar',
  props: {
    collapsed: {
      type: Boolean,
      default: true
    },
    horizontal: {
      type: Boolean,
      default: false
    }
  },
  components: {
    navUser,
    breadCrumb
  },
  data() {
    return {
      breadList: [{
        path: '/dashboard',
        meta: {
          title: '首页',
          icon: 'dashboard'
        }
      }],
      isFullscreen: false
    };
  },
  computed: {
    count() {
      return this.$store.state.user.warningNum;
    }
  },
  methods: {
    toggleOpen() {
      this.$store.commit('setting/TOGGLE_OPEN');
    },
    screenFull() {
      if (!screenfull.isEnabled) {
        this.$message.warning('不好意思，你的电脑不支持全屏，赶紧换个电脑吧，谢谢~');
        return false;
      }
      screenfull.toggle();
      this.isFullscreen = !this.isFullscreen;
    },
    changeVisible() {
      this.$store.dispatch('setting/changeVisible', true);
    },
    toNotice() {
      // this.count = 0;
      this.$router.push({
        name: 'warning'
      });
    }
  }
};